import { Directive, inject, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { featureFlags } from '../../../environments/environment';

@Directive({
  selector: '[featureFlag]'
})
export class FeatureFlagDirective implements OnInit {
  @Input() featureFlag!: string;
  @Input() featureFlagElse!: TemplateRef<any>;

  templateRef: TemplateRef<any> = inject(TemplateRef);
  viewContainer: ViewContainerRef = inject(ViewContainerRef);

  ngOnInit(): void {
    if (this.isEnabled()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (this.featureFlagElse) {
      this.viewContainer.createEmbeddedView(this.featureFlagElse);
    } else {
      this.viewContainer.clear();
    }
  }

  isEnabled() {
    return featureFlags[this.featureFlag as keyof typeof featureFlags];
  }
}
